<template>
  <div
    v-if="show"
    class="rt-msg-notice"
  >
    <div class="notice-header">
      <div class="desc">
        <rt-icon
          name="rt-base-notification"
          color="#0059b3"
        />
        <span>{{ $tx('消息通知', 'xpc.common.messageNotification') }}</span>
      </div>
      <rt-button
        class="close"
        icon-name="rt-base-close"
        text
        icon-size="21"
        @click="close"
      />
    </div>
    <div class="notice-content">
      <div class="title">
        {{ list[index].title }}
      </div>
      <div class="sub">
        {{ list[index].sub }}
      </div>
    </div>
    <div class="notice-footer">
      <rt-button
        type="plain"
        text
        @click="view(list[index].url)"
      >
        {{ $tx('查看', 'xpc.common.look') }}
      </rt-button>
      <div
        v-if="len > 1"
        class="operation"
      >
        <rt-button
          text
          icon-name="rt-base-arrow_left"
          @click="prev"
        >
          {{ $tx('上一条', 'xpc.common.prev') }}
        </rt-button>
        <rt-button
          text
          suffix-icon="rt-base-arrow_right"
          @click="prev"
        >
          {{ $tx('下一条', 'xpc.common.next') }}
        </rt-button>
      </div>
    </div>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
import RtButton from '../button/rtButton';
export default {
  name: 'RtMsgNotice',
  components: {
    RtIcon,
    RtButton
  },
  props: {
    list: {
      type: Array,
      default: () => [],
      required: true,
      validator: function (val) {
        let copyVal = JSON.parse(JSON.stringify(val));
        for (let i = 0; i < copyVal.length; i++) {
          if (!copyVal[i].title || !copyVal[i].sub || !copyVal[i].url) {
            console.log('消息通知的每一个字段都不能为空');
            return false;
          }
        }
        return true;
      }
    }
  },
  data () {
    return {
      show: !!this.list.length,
      index: 0,
      len: this.list.length
    };
  },
  methods: {
    close () {
      this.show = false;
    },
    view (val) {
      window.open(val);
    },
    prev () {
      if (this.index === 0) {
        this.index = this.len - 1;
      } else {
        this.index -= 1;
      }
    },
    next () {
      if (this.index === this.len - 1) {
        this.index = 0;
      } else {
        this.index += 1;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtMsgNotice.vue?75037086